var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  fill: "none",
  viewBox: "0 0 159 159"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#server_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "server_svg__b",
  width: 159,
  height: 159,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 79.5,
  cy: 79.5,
  r: 79.5,
  fill: "#000"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#5472cc",
  strokeWidth: 2,
  mask: "url(#server_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 79.5,
  cy: 80.106,
  r: 78.5,
  fill: "#f3f4f6"
}), /*#__PURE__*/React.createElement("rect", {
  width: 91.278,
  height: 136.22,
  x: 33.859,
  y: 32.73,
  fill: "#5472cc",
  fillOpacity: 0.24,
  rx: 20
}), /*#__PURE__*/React.createElement("rect", {
  width: 81.843,
  height: 124.87,
  x: 38.992,
  y: 44.544,
  fill: "#5472cc",
  fillOpacity: 0.24,
  rx: 6
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 61.152,
  height: 6.772,
  x: 48.926,
  y: 55.724,
  fill: "#5472cc",
  fillOpacity: 0.24,
  stroke: "#5472cc",
  strokeWidth: 2,
  rx: 3.386
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 37.238,
  height: 6.772,
  x: 60.883,
  y: 67.277,
  fill: "#5472cc",
  fillOpacity: 0.24,
  stroke: "#5472cc",
  strokeWidth: 2,
  rx: 3.386
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 46.015,
  height: 4.292,
  x: 63.48,
  y: 91.272,
  fill: "#5472cc",
  fillOpacity: 0.24,
  stroke: "#5472cc",
  strokeWidth: 2,
  rx: 2.146
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 7.473,
  height: 7.473,
  x: 49.5,
  y: 89.998,
  fill: "#5472cc",
  fillOpacity: 0.24,
  stroke: "#5472cc",
  strokeWidth: 2,
  rx: 3.737
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 46.015,
  height: 4.292,
  x: 63.48,
  y: 103.526,
  fill: "#5472cc",
  fillOpacity: 0.24,
  stroke: "#5472cc",
  strokeWidth: 2,
  rx: 2.146
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 7.473,
  height: 7.473,
  x: 49.5,
  y: 102.251,
  fill: "#5472cc",
  fillOpacity: 0.24,
  stroke: "#5472cc",
  strokeWidth: 2,
  rx: 3.737
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 46.015,
  height: 4.292,
  x: 63.48,
  y: 115.78,
  fill: "#5472cc",
  fillOpacity: 0.24,
  stroke: "#5472cc",
  strokeWidth: 2,
  rx: 2.146
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 7.473,
  height: 7.473,
  x: 49.5,
  y: 114.505,
  fill: "#5472cc",
  fillOpacity: 0.24,
  stroke: "#5472cc",
  strokeWidth: 2,
  rx: 3.737
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "server_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f3f4f6",
  d: "M0 0h159v159H0z"
})))));
export default SvgServer;